var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResizePage),expression:"onResizePage"}],staticClass:"account-think-page"},[_c('account-think-banner',{staticClass:"at-banner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }